<template>
  <!-- sidebar -->
  <div ref="aside">
    <div
      class="sidebar-overlay"
      :class="{ 'sidebar-overlay--visible': sidebarOpen }"
      @click="toggleOverlay()"
    ></div>
    <div
      class="sidebar"
      :class='{"sidebar--open" : sidebarOpen}'
    >
      <nav class="sidebar__nav">
        <ul class="sidebar__nav-list">
          <li v-for="item in navItems" :key="item.label" class="sidebar__nav-list-item">
            <SidebarComponent
              :item="item"
              :open="submenus[`${item.key}Open`]"
              :callback="toggleSubmenu"
            />
            <ul
              v-if="'subitems' in item"
              class="sidebar__nav-subitems"
              :class="{ open: submenus[`${item.key}Open`] }"
            >
              <li
                v-for="subitem in item.subitems" :key="subitem.label"
                class="sidebar__nav-list-subitem"
              >
                <SidebarComponent
                  :item="subitem"
                  subitem
                />
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div class="sidebar__nav sidebar__subitems">
        <ul class="sidebar__nav-list">
          <li v-for="subitem in navSubItems" :key="item.label" class="sidebar__nav-list-item">
            <SidebarComponent :item="subitem" />
          </li>
        </ul>
      </div>
      <div class="sidebar__close">
        <button
          class="sidebar__close__button"
          @click="toggleSidebar"
        >
          <ion-icon class="icon" name="close-sharp" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SidebarComponent from './SidebarComponent.vue';

export default {
  props: {
    item: {
      type: String,
      required: true
    }
  },

  components: {
    SidebarComponent,
  },

  data() {
    return {
      showMask: false,
      showMenu: false,
      submenus: {
        integrationsOpen: false,
        configurationsOpen: false
      },
    };
  },

  computed: {
    ...mapGetters('general', ['sidebarOpen']),

    navItems() {
      return [
        {
          label: 'Parceiros',
          href: 'https://menv.io/parceiros',
          external: true,
          badge: {},
          visible: () => true,
        },
        {
          label: 'Blog',
          href: 'https://melhorenvio.com.br/blog',
          external: true,
          badge: {},
          visible: () => true,
        },
        {
          label: 'Suporte',
          href: MEConfig.get('dash.url') + '/suporte',
          badge: {},
          visible: () => true,
        },
        {
          label: 'Rastreio',
          href: 'https://melhorrastreio.com.br/',
          external: true,
          badge: {},
          visible: () => true,
        },
      ];
    },

    navSubItems() {
      return [
        {
          label: 'Entrar',
          icon: 'log-in-outline',
          ion: true,
          href: '/login',
          badge: {},
        },
        {
          label: 'Cadastrar',
          icon: 'person-outline',
          ion: true,
          href: '/cadastre-se',
          badge: {},
        }
      ];
    }
  },

  mounted() {
    this.$root.$asideMenu = this.$refs.aside;
  },

  methods: {
    ...mapActions('general', ['changeSidebarStatus']),

    async toggleSidebar() {
      this.changeSidebarStatus(!this.sidebarOpen);

      await this.$nextTick();

      // close submenu when sidebar is closed
      if (this.sidebarOpen === false) {
        this.closeSubmenus();
      }
    },

    toggleSubmenu(menu, evt) {
      const submenu = `${menu}Open`;
      const element = evt.currentTarget;
      const isRootElement = element.classList.contains('sidebar__nav-list-item');
      const rootElement = isRootElement ? evt.currentTarget : evt.currentTarget.parentNode.parentNode;

      if (submenu in this.submenus) {
        this.submenus[submenu] = !this.submenus[submenu];

        this.closeSubmenus(submenu);
      }

      // open sidebar when submenu is opened
      if (window.matchMedia("(max-width: 1279px)").matches) {
        if (this.submenus[`${menu}Open`] === true) {
          this.changeSidebarStatus(true);
        }
      }

      if (this.submenus[submenu]) {
        rootElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    },

    // close sidebar and submenu when overlay is clicked
    toggleOverlay() {
      this.closeSubmenus();
      this.changeSidebarStatus(false);
    },

    // Close all submenus if any submenus is provided.
    closeSubmenus(clickedSubmenu = null) {
      const submenus = Object.keys(this.submenus);

      if (clickedSubmenu) {
        // Close all the submenus that aren't the clicked menu
        submenus
          .filter(key => key !== clickedSubmenu)
          .forEach(submenu => {
            this.submenus[submenu] = false;
          });
      } else {
        submenus.forEach(submenu => {
          this.submenus[submenu] = false;
        });
      }
    }
  }
};
</script>
